import { Component, OnInit } from '@angular/core';
import { staticData } from './success-static-data';

@Component({
  selector: 'app-referral-success-stories',
  templateUrl: './referral-success-stories.component.html',
  styleUrls: ['./referral-success-stories.component.scss']
})
export class ReferralSuccessStoriesComponent implements OnInit {

  constructor() { }
  getdescriptions: any[] = staticData;
  breakpoints = {
    1920: {
      perView: 1.8,
      gap: 20
    },
    2560: {
      perView: 2.2,
      gap: 20
    },
    1536: {
      perView: 1.5,
      gap: 20
    },
    1440: {
      perView: 1.4,
      gap: 10
    },
    1370: {
      perView: 1.28,
      gap: 10
    },
    1366: {
      perView: 1.5,
      gap: 10
    },
    1240: {
      perView: 1,
      gap: 20
    },
    1024: {
      perView: 1,
      gap: 10
    },
    600: {
      perView: 1,
      startAt: 1,
      focusAt: 'center',
      gap: 10
    }
  };
  ngOnInit() {
  }

}
